import {
  MessageSquare,
  Type,
  Image,
  Video,
  Music,
  Code,
  File,
  Twitter,
  Upload,
  Wrench,
  StickyNote
} from 'lucide-react';
import { env } from '@/lib/env';

const ALL_BUTTONS = [
  { id: 'prompt', label: 'Prompt', icon: Type, data: { viewMode: 'primitive' } },
  { id: 'llm', label: 'LLM', icon: MessageSquare, data: { viewMode: 'transform' } },
  { id: 'image', label: 'Generate Image', icon: Image },
  { id: 'video', label: 'Generate Video', icon: Video },
  { id: 'audio', label: 'Generate Audio', icon: Music },
  { id: 'stickyNote', label: 'Sticky Note', icon: StickyNote },
  {
    id: 'tool',
    label: 'Tool',
    icon: Wrench,
    // Intentionally empty: user will pick a specific tool from the ToolNode chooser cards.
    data: {},
  },
  { id: 'upload', label: 'Upload Assets', icon: Upload },
  { id: 'file', label: 'Upload File', icon: File },
  { id: 'code', label: 'Code', icon: Code, data: { content: { language: 'javascript' } } },
  { id: 'tweet', label: 'Tweet', icon: Twitter },
] as const;

const enabledList = (env.NEXT_PUBLIC_ENABLED_NODE_TYPES || '')
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean);

export const nodeButtons = (enabledList.length
  ? (ALL_BUTTONS.filter((b) => {
      // prompt 和 llm 都映射到 text 类型
      if (b.id === 'prompt' || b.id === 'llm') {
        return enabledList.includes('text');
      }
      return enabledList.includes(b.id);
    }) as unknown as typeof ALL_BUTTONS)
  : (ALL_BUTTONS.filter((b) => ['prompt', 'llm', 'image', 'video', 'audio', 'tool', 'upload', 'file', 'stickyNote'].includes(b.id)) as unknown as typeof ALL_BUTTONS)
);
